import { QueryClientProvider } from "@tanstack/react-query";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { useEffect, useRef } from "react";
import { ThemeProvider } from "@/components/layout/ThemeProvider";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { RouteProgress } from "@/components/shared/route-progress";
import { Toaster } from "@/components/ui/sonner";
import { useSession } from "@/lib/auth-client";
import { queryClient } from "@/lib/query";

export function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { data: session } = useSession();
  const userId = session?.user?.id;
  const prevUserId = useRef(userId);

  // Backstop for the explicit clears in Sidebar/LoginForm/SignupForm — catches
  // any future auth transition that doesn't go through those call sites. Skips
  // the very first render so a fresh tab doesn't pay for a redundant clear.
  useEffect(() => {
    if (prevUserId.current !== userId) {
      queryClient.clear();
      prevUserId.current = userId;
    }
  }, [userId]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <RouteProgress />
        <ErrorBoundary resetKey={pathname}>
          <Outlet />
        </ErrorBoundary>
        <Toaster />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
